import React from 'react'
import { PrismicRichText } from '@prismicio/react'

const Products = ({ slice }) => {
  return (
    <section className='component-products mx-auto w-full max-w-screen-xl px-6 py-10 lg:py-20'>
      {slice.primary.title.text && (
        <div className='prose prose-lg mb-10 max-w-none text-center dark:prose-invert lg:prose-lg'>
          <PrismicRichText field={slice.primary.title.richText} />
        </div>
      )}
      <ul className={`grid grid-cols-1 md:grid-cols-2 gap-10 max-w-screen-xl mx-auto`}>
        {slice.items.map((product, index) => {
          product = product.product
          const title = product.title?.split('|')
          var productImage = product.image?.src
          return (
            <li className='grid w-full grid-cols-12 items-start gap-x-6 gap-y-8 lg:grid-cols-12 lg:gap-x-8' key={`product-${index}`}>
              <div className='col-span-4 lg:col-span-5'>
                <div className='aspect-h-1 aspect-w-1 overflow-hidden rounded-md bg-slate-100'>
                  <img className='object-cover object-center' src={productImage} alt={product.image.alt || ''} />
                </div>
              </div>
              <div className='col-span-8 lg:col-span-7'>
                <div className='prose max-w-none lg:prose dark:prose-invert'>
                  <div className='not-prose'>
                    <h2 className='uppercase text-2xl dark:text-brandYellow'>{title[0]}</h2>
                  </div>
                  <div className='not-prose dark:text-white capitalize text-xl font-semibold mb-4'>{product.vendor}</div>
                  <div className='text-slate-700 dark:text-slate-200 uppercase mb-2'>
                    {product.tags?.replace(',', ' |')}
                    <br />
                    {title[1]}
                  </div>
                  {product.variants.map((variant, index) => {
                    return (
                      <div className='not-prose' key={`product-${index}`}>
                        <ul className='list-none'>
                          <li className='text-base text-slate-900 dark:text-white mb-1'>
                            {variant.title !== 'Default Title' && `${variant.title} -`} £{variant.price}
                          </li>
                        </ul>
                      </div>
                    )
                  })}
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}

export default Products
